var _clipPath;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBirthdayHat1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 450.519,
    height: "160mm",
    viewBox: "0 0 119.2 160",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(584.34 16.9526 16.9526 -584.34 3805.94 22983.2)",
    spreadMethod: "pad",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#fe7270"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#ee3264"
    },
    offset: 1
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4134.33 22995.8s-174.63 325.4-301.42 266.6c-159.57-73.9 304.42-554.3 304.42-554.3s328.96 424.2 229.04 514.7c-99.92 90.6-232.04-227-232.04-227z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M164.851 161.706 105.918 35.711 45.65 161.106s1.691 17.514 62.059 18.102c51.455.501 57.141-17.502 57.141-17.502",
    style: {
      fill: "#35b1f0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0299607
    },
    transform: "translate(-45.651 -19.218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.71 91.824c-11.186-.11-20.352-.799-27.87-1.852l-3.443 7.163c8.114 1.343 18.359 2.25 31.313 2.376 11.032.107 19.955-.638 27.174-1.873l-3.352-7.165c-6.583.916-14.438 1.443-23.822 1.351",
    style: {
      fill: "#ff3636",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0299607
    },
    transform: "translate(-45.651 -19.218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.71 78.07c-8.258-.08-15.411-.48-21.62-1.106l-3.506 7.298c6.978.85 15.264 1.4 25.126 1.493 8.142.082 15.135-.305 21.144-1.007l-3.43-7.331c-5.201.473-11.074.717-17.714.654",
    style: {
      fill: "#ee3264",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0299607
    },
    transform: "translate(-45.651 -19.218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.71 133.09c-22.327-.22-36.621-2.751-45.779-5.858l-3.135 6.524c8.914 3.616 23.855 6.777 48.914 7.018 22.154.217 35.819-2.997 44.203-6.73l-3.02-6.456c-8.532 3.178-21.51 5.692-41.183 5.502",
    style: {
      fill: "#ffda3e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0299607
    },
    transform: "translate(-45.651 -19.218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.71 119.334c-18.084-.176-30.898-1.87-39.983-4.158l-3.265 6.791c9.198 2.73 22.88 4.855 43.248 5.054 17.883.173 30.233-1.888 38.742-4.652l-3.156-6.745c-8.328 2.274-19.8 3.865-35.586 3.71",
    style: {
      fill: "#feb1b2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0299607
    },
    transform: "translate(-45.651 -19.218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.71 105.58c-14.429-.14-25.498-1.25-34-2.852l-3.364 6.997c8.884 1.97 20.951 3.382 37.364 3.54 14.241.14 24.971-1.14 33.05-3.064l-3.263-6.975c-7.646 1.517-17.383 2.474-29.787 2.354",
    style: {
      fill: "#f68121",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0299607
    },
    transform: "translate(-45.651 -19.218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.71 171.52c37.464.367 50.662-9.076 55.071-14.239l-2.461-5.262c-6.198 5.226-20.482 12.13-52.61 11.817-36.298-.354-51.378-6.827-57.636-11.932l-2.507 5.217c4.21 5.173 17.617 13.987 60.143 14.4",
    style: {
      fill: "#9e7cdb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0299607
    },
    transform: "translate(-45.651 -19.218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.71 148.462c-28.159-.273-43.548-4.232-51.956-8.375l-2.921 6.077c7.566 4.669 23.079 9.674 54.877 9.985 28.183.275 42.635-5.003 49.943-9.833l-2.813-6.012c-7.998 4.295-22.186 8.402-47.13 8.158",
    style: {
      fill: "#94de4b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0299607
    },
    transform: "translate(-45.651 -19.218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.408 36.772-3.653 7.6c1.92.06 3.9.1 5.955.12.784.008 1.556.01 2.32.01l-3.61-7.715-1.012-.015",
    style: {
      fill: "#ff3636",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0299607
    },
    transform: "translate(-45.651 -19.218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.71 64.315c-5.575-.054-10.647-.252-15.266-.57l-3.561 7.412c5.539.473 11.778.776 18.827.845 5.502.053 10.476-.107 14.98-.43l-3.495-7.474c-3.55.178-7.37.257-11.485.217",
    style: {
      fill: "#94de4b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0299607
    },
    transform: "translate(-45.651 -19.218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.71 50.561a283.3 283.3 0 0 1-8.822-.221l-3.611 7.511c3.842.214 7.973.351 12.433.395 3.061.03 5.955-.008 8.701-.1l-3.555-7.6c-1.664.025-3.375.03-5.146.015",
    style: {
      fill: "#ffda3e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0299607
    },
    transform: "translate(-45.651 -19.218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.925 178.088c-14.082-1.432-23.245-4.043-29.205-6.796l2.738-6.522c6.073 2.366 14.81 4.509 27.38 5.723l-.913 7.595m1.828-15.196c-11.22-1.028-19.453-2.789-25.492-4.8l2.856-6.803c5.89 1.69 13.563 3.132 23.551 4l-.915 7.603",
    style: {
      fill: "#9cd9f8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0299607
    },
    transform: "translate(-45.651 -19.218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.839 170.493c-12.572-1.214-21.308-3.357-27.38-5.723l2.802-6.677c6.04 2.01 14.273 3.77 25.492 4.799l-.914 7.6",
    style: {
      fill: "#cfbfed",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0299607
    },
    transform: "translate(-45.651 -19.218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.584 147.678c-8.852-.728-15.92-1.901-21.566-3.3l2.94-7.008c5.32 1.145 11.754 2.091 19.541 2.694l-.915 7.614m1.832-15.23c-6.783-.496-12.559-1.249-17.481-2.168l2.371-5.651c4.565.76 9.81 1.382 15.834 1.801l-.724 6.018m1.641-13.641c-5.103-.336-9.658-.812-13.721-1.394l2.41-5.744c3.634.46 7.634.84 12.036 1.115l-.725 6.023m1.643-13.654c-3.543-.206-6.83-.479-9.879-.81l2.443-5.821c2.56.241 5.277.445 8.16.605l-.724 6.026m1.643-13.665c-2.072-.107-4.059-.234-5.965-.384l2.472-5.89c1.367.09 2.772.172 4.22.241l-.727 6.033m1.646-13.677c-.673-.03-1.336-.061-1.991-.097l2.497-5.949c.073.003.146.008.22.01l-.726 6.036",
    style: {
      fill: "#9cd9f8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0299607
    },
    transform: "translate(-45.651 -19.218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.425 99.127a212.17 212.17 0 0 1-8.16-.605l3.113-7.418c1.906.15 3.893.277 5.965.384l-.918 7.64",
    style: {
      fill: "#ff9c9c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0299607
    },
    transform: "translate(-45.651 -19.218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.07 85.455c-1.448-.069-2.853-.15-4.22-.242l3.148-7.499c.655.036 1.318.067 1.99.097l-.919 7.644",
    style: {
      fill: "#f79bb3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0299607
    },
    transform: "translate(-45.651 -19.218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5 140.064c-7.788-.603-14.222-1.55-19.541-2.694l2.976-7.09c4.922.919 10.698 1.672 17.48 2.168l-.916 7.616",
    style: {
      fill: "#ffeda0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0299607
    },
    transform: "translate(-45.651 -19.218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.14 126.43c-6.024-.42-11.27-1.04-15.834-1.801l3.03-7.216c4.063.582 8.618 1.058 13.721 1.394l-.917 7.623",
    style: {
      fill: "#ffd9d9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0299607
    },
    transform: "translate(-45.651 -19.218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.782 112.784a190.033 190.033 0 0 1-12.036-1.115l3.075-7.326c3.05.331 6.336.604 9.879.81l-.918 7.63",
    style: {
      fill: "#fbc192",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0299607
    },
    transform: "translate(-45.651 -19.218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.668 155.289c-9.988-.868-17.66-2.31-23.551-4l2.9-6.911c5.647 1.399 12.715 2.572 21.567 3.3l-.916 7.61M98.715 71.775l-.22-.01.31-.74-.09.75",
    style: {
      fill: "#cbefa7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0299607
    },
    transform: "translate(-45.651 -19.218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.8 179.218a281.862 281.862 0 0 1-9.992-.194 164.137 164.137 0 0 0 4.108-7.562 294.046 294.046 0 0 0 5.885.072c35.87 0 48.654-9.186 52.98-14.253l-2.461-5.262c-6.062 5.112-19.862 11.825-50.518 11.827-.69 0-1.384-.004-2.092-.01-.04 0-.081-.004-.121-.004a205.142 205.142 0 0 0 3.3-7.677c26.103-.138 39.736-5.197 46.764-9.84l-2.107-4.504 9.305 19.893s-5.525 17.515-55.05 17.512",
    style: {
      fill: "#3293c5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0299607
    },
    transform: "translate(-45.651 -19.218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.801 171.533a309.203 309.203 0 0 1-5.885-.072 186.727 186.727 0 0 0 3.673-7.628c.04 0 .08.004.12.004.709.004 1.402.01 2.093.01 30.656-.004 44.456-6.715 50.518-11.827l2.461 5.262c-4.326 5.067-17.11 14.253-52.98 14.253",
    style: {
      fill: "#836ab5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0299607
    },
    transform: "translate(-45.651 -19.218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.855 148.431a226.736 226.736 0 0 0 2.656-7.759c17.072-.59 28.189-3.417 35.402-6.628l2.927 6.26c-7.317 3.928-19.812 7.7-40.985 8.127m5.014-15.542c.582-2.051 1.134-4.107 1.652-6.156 11.212-.654 19.625-2.315 25.93-4.364l-1.785-3.817 4.227 9.036c-6.803 2.535-16.43 4.647-30.024 5.3m3.477-13.959c.443-2.066.85-4.12 1.222-6.158 6.765-.53 12.438-1.438 17.192-2.57l2.536 5.423c-5.499 1.501-12.372 2.705-20.95 3.305m16.026-13.832-.875-1.87c-3.71.735-7.914 1.34-12.677 1.753.288-2.072.534-4.12.738-6.133 3.388-.313 6.489-.723 9.326-1.209l-1.966-4.203 5.454 11.662m-12.24-13.993c.096-2.076.14-4.104.128-6.08.884-.086 1.75-.177 2.594-.276l2.678 5.725c-1.712.237-3.51.45-5.4.63",
    style: {
      fill: "#3293c5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0299607
    },
    transform: "translate(-45.651 -19.218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.558 98.847c.266-2.641.459-5.226.575-7.743 1.888-.18 3.687-.394 5.399-.631l1.386 2.962 1.966 4.203c-2.837.486-5.938.896-9.326 1.21",
    style: {
      fill: "#cd3436",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0299607
    },
    transform: "translate(-45.651 -19.218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.26 85.025a95.373 95.373 0 0 0-.238-6.33l2.832 6.053c-.844.099-1.71.19-2.594.277",
    style: {
      fill: "#c0315a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0299607
    },
    transform: "translate(-45.651 -19.218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.511 140.672a228.38 228.38 0 0 0 2.358-7.783c13.593-.654 23.221-2.766 30.024-5.3l3.02 6.455c-7.213 3.211-18.33 6.038-35.402 6.628",
    style: {
      fill: "#cdb23d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0299607
    },
    transform: "translate(-45.651 -19.218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.521 126.733a218.36 218.36 0 0 0 1.825-7.804c8.578-.6 15.451-1.804 20.95-3.305l1.37 2.928 1.786 3.817c-6.306 2.049-14.719 3.71-25.93 4.364",
    style: {
      fill: "#cc9396",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0299607
    },
    transform: "translate(-45.651 -19.218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.568 112.771c.479-2.631.897-5.229 1.252-7.791 4.763-.413 8.966-1.018 12.677-1.754l.875 1.87 2.388 5.105c-4.754 1.132-10.427 2.04-17.192 2.57",
    style: {
      fill: "#c66e21",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0299607
    },
    transform: "translate(-45.651 -19.218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.888 156.156a218.68 218.68 0 0 0 2.967-7.725c21.173-.427 33.668-4.199 40.985-8.127l.706 1.509 2.107 4.503c-7.028 4.644-20.66 9.703-46.765 9.84",
    style: {
      fill: "#7bb547",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0299607
    },
    transform: "translate(-45.651 -19.218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.88 25.334s-4.489-8.662-12.86-5.37c-8.405 3.306 14.058 21.304 14.058 21.304s17.122-16.74 11.795-20.725c-5.326-3.985-12.994 4.791-12.994 4.791",
    style: {
      fill: "#55cef8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0299607
    },
    transform: "translate(-45.651 -19.218)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(.03528 0 0 -.02545 -85.795 595.364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4134.33 22995.8s-174.63 325.4-301.42 266.6c-159.57-73.9 304.42-554.3 304.42-554.3s328.96 424.2 229.04 514.7c-99.92 90.6-232.04-227-232.04-227",
    style: {
      fill: "url(#b)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthdayHat1);
export default __webpack_public_path__ + "static/media/birthday_hat_1.ba8de13f87ce1f6d44fd0eba9e55ab63.svg";
export { ForwardRef as ReactComponent };